<template>
    <section class="subscription-personal-data-management">
        <div class="row">
            <div class="mb-3 px-0">
                <data-entry-column :title="$t('cdb.subscriptions.tab_personal_data')" :full-width="true">
                    <template v-slot:value>
                        <p>{{ getName }}</p>
                        <component
                            v-bind:is="getAddressComponent"
                            :address="invoiceAddress"
                        ></component>
                    </template>
                </data-entry-column>
            </div>
        </div>
    </section>
</template>

<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import AddressBox from "./AddressBox.vue";

export default {
    name: 'SubscriptionPersonalDataManagement',

    components: {
        DataEntryColumn, AddressBox
    },

    props: {
        subscriptionData: null
    },

    data() {
        return {
            user: this.$root.user.state.data,
            invoiceAddress: this.subscriptionData.invoice_address_data
        }
    },

    methods: {
    },

    computed: {
        getName() {
            return this.subscriptionData.user_name ?? ''
        },
        getAddressComponent(){
            return "address-box";
        }
    },

    mounted() {
    }
}
</script>
